import { Component, NgZone, OnInit } from '@angular/core';
import { PushNotificationService } from './services/push-notification-service.service';
import { Capacitor } from '@capacitor/core';
import { App, URLOpenListenerEvent } from '@capacitor/app';
import { SplashScreenService } from './services/aumye-android-app/aumye-splash.service';
import { Router } from '@angular/router';
import { FirebaseMessagingService } from './services/firebase-messaging.service';
import { AumyeFirebaseRealtimeDbService } from './services/realTimeData/aumye-firebase-realtime-db.service';
import { IAumyeState } from './state-management/states/aumye.state';
import { Store } from '@ngrx/store';
import { FirebaseAuthService } from './services/firebase/firebase-auth.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
  imageSrc: string = null;
  constructor(
    private pushService: PushNotificationService,
    private splashService: SplashScreenService,
    private router: Router,
    private zone: NgZone,
    private firebaseRealTime: AumyeFirebaseRealtimeDbService,
    private messagingService: FirebaseMessagingService
  ) {}
  async ngOnInit(): Promise<void> {
    // Initialize Firebase Messaging early (before login)
    await this.initializeFirebaseMessaging();

    this.initializeServicesForAuthenticatedUser();
    this.setViewportForNative();

    if (!this.firebaseRealTime.isRealtimeInitiated) {
      this.firebaseRealTime.initRealTime();
      this.firebaseRealTime.validateWebsocketToken();
    }
  }
  private async initializeFirebaseMessaging(): Promise<void> {
    try {
      // Initialize Firebase Messaging
      await this.messagingService.initialize();

      const token = await this.messagingService.requestPermission();

      if (token) {
        console.log('FCM Token generated and stored:', token);

        // Setup listeners based on platform
        if (Capacitor.isNativePlatform()) {
          await this.messagingService.setupMobileNotificationListeners();
        } else {
          await this.messagingService.listenToNotifications();
          await this.messagingService.syncNotificationsToLocalStorage();
        }
      }
    } catch (error) {
      console.error('Firebase Messaging initialization error:', error);
    }
  }
  private initializeServicesForAuthenticatedUser(): void {
    if (Capacitor.isNativePlatform()) {
      this.initializeApp();
      this.initFlash();
      this.pushService.initialize();
      this.pushService.getDeliveredNotifications();
    }
  }

  // ngOnInit(): void {
  //   this.setViewportForNative();
  //   this.firebaseAuthService.isSignedIn().then((signedIn) => {
  //     if (signedIn) {
  //       console.log('User is signed in → initialize Firebase logic.');
  //       if (Capacitor.getPlatform() === 'android') {
  //         this.initializeApp();
  //         this.initFlash();
  //         this.pushService.initialize();
  //         this.pushService.getDeliveredNotifications();
  //       } else if (Capacitor.getPlatform() === 'ios') {
  //       } else {
  //         // Initialize notification handling
  //         this.initializePushNotifications();
  //         this.messagingService.listenToNotifications();
  //         this.messagingService.syncNotificationsToLocalStorage();
  //       }
  //     }
  //   });
  //   this.firebaseRealTime.initRealTime();
  //   this.firebaseRealTime.validateWebsocketToken();
  // }
  // Restrict zoom only for native platforms (Android/iOS)
  setViewportForNative() {
    const isNative = Capacitor.isNativePlatform();

    // If it's a native device (Android or iOS), restrict zoom
    if (isNative) {
      const viewportMeta = document.getElementById(
        'viewport-meta'
      ) as HTMLMetaElement;
      viewportMeta.setAttribute(
        'content',
        'width=device-width, initial-scale=1, maximum-scale=1, user-scalable=no'
      );
    } else {
      // Allow zoom for browsers (Web)
      const viewportMeta = document.getElementById(
        'viewport-meta'
      ) as HTMLMetaElement;
      viewportMeta.setAttribute(
        'content',
        'width=device-width, initial-scale=1'
      );
    }
  }
  private async initializePushNotifications() {
    try {
      // Check current notification permission
      const currentPermission = await this.checkNotificationPermission();
      if (currentPermission === 'default') {
        this.requestNotificationPermission();
      } else if (currentPermission === 'granted') {
        // Automatically get and send token
        await this.autoEnableNotifications();
      }

      // Always listen for notifications
      this.messagingService.listenToNotifications();
    } catch (error) {
      console.error('Push notification initialization error:', error);
    }
  }
  private async checkNotificationPermission(): Promise<NotificationPermission> {
    // Check if notifications are supported
    if (!('Notification' in window)) {
      console.warn('This browser does not support notifications');
      return 'denied';
    }

    // Return current permission status
    return Notification.permission;
  }
  async requestNotificationPermission() {
    try {
      // Request permission
      const token = await this.messagingService.requestPermission();

      if (token && token.length > 1) {
        // Send token to backend
        await this.sendTokenToServer(token);

        // Provide user feedback
        this.showSuccessNotification();
      }
    } catch (error) {
      console.error('Notification permission error:', error);
    }
  }
  private showSuccessNotification() {
    // Optional: Show a toast or alert that notifications are enabled
    // You could use a toast service or simple alert
    alert('Notifications enabled successfully!');
  }
  private async autoEnableNotifications() {
    try {
      const token = await this.messagingService.requestPermission();
      if (token) {
        // console.log('Web Token: ', token);
      }
    } catch (error) {
      console.error('Auto enable notifications error:', error);
    }
  }
  async enableNotifications() {
    const token = await this.messagingService.requestPermission();
    // Send token to your backend
    this.sendTokenToServer(token);
  }
  private sendTokenToServer(token: string) {
    // Implement method to send token to your backend
    localStorage.setItem('Web_Token', token);
  }
  async initFlash() {
    // this.updateImageSource();
    // window.addEventListener('resize', this.updateImageSource.bind(this));
    // window.addEventListener(
    //   'orientationchange',
    //   this.updateImageSource.bind(this)
    // );
    // Show splash screen for 2 seconds
    // await this.splashService.show({ showDuration: 2000 });
    await this.splashService.hide();
  }
  updateImageSource() {
    const screenWidth = window.innerWidth;
    const screenHeight = window.innerHeight;
    const isPortrait = screenHeight > screenWidth;

    // Logic to switch image based on orientation and size
    if (isPortrait) {
      this.imageSrc = 'assets/pt_splash.gif';
    } else {
      this.imageSrc = 'assets/ld_splash.gif';
    }
  }
  initializeApp() {
    App.addListener('appUrlOpen', (event: URLOpenListenerEvent) => {
      this.zone.run(() => {
        const url = event.url;
        const regex = /(?:https?:\/\/[^/]+)(\/.*)/;
        const match = url.match(regex);
        console.log(url, match && match[1]);
        if (match && match[1]) {
          // Navigate to the extracted slug path
          this.router.navigateByUrl(match[1]);
        }
        // If no match, do nothing - let regular routing
        // logic take over
      });
    });
  }
}
